export const START_NEW_ORDER_EVENT = 'ash:start-new-order'
export const START_NEW_KIT_REGISTRATION_EVENT = 'ash:start-new-kit-registration'
